import { Alert, CardProps, List } from 'antd';
import './styles.css';
import { Notifications, NotificationsItem } from './NotificationItem';

type Props = {
    data?: Notifications[];
    loading?: boolean;
    error?: any;
} & CardProps;

export const NotificationsCard = ({
    data,
    loading,
    error,
    ...others
}: Props) => {
    return (
        <>
            {error ? (
                <Alert
                    message="Error"
                    description={error.toString()}
                    type="error"
                    showIcon
                />
            ) : loading ? (
                null
            ) : (
                <List
                    itemLayout="vertical"
                    size="large"
                    pagination={{
                        size: "small",
                        onChange: (page) => {
                            console.log(page);
                        },
                        pageSize: 5,
                        align: 'center',
                    }}
                    dataSource={data}
                    renderItem={(item) => (
                        <List.Item key={item.notification_id}>
                            <NotificationsItem data={item} />
                        </List.Item>
                    )}
                />
            )}
        </>
    );
};
